import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function AuthCallback() {
  const { googleLogin } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/login');
      return;
    }

    const sessionId = match[1];
    (async () => {
      try {
        const userData = await googleLogin(sessionId);
        const role = userData.role;
        if (role === 'admin') navigate('/admin', { replace: true });
        else if (role === 'lawyer') navigate('/lawyer', { replace: true });
        else navigate('/client', { replace: true });
      } catch {
        navigate('/login', { replace: true });
      }
    })();
  }, [googleLogin, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA]">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#B48E4B] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#475569]">Authenticating...</p>
      </div>
    </div>
  );
}
